// @flow

import * as React from 'react';
import { Modal, Spin } from 'antd';
import { getFileViewUri } from '../../HttpRequests/files';
import handleException from '../../Core/Helpers/handleException';
import styles from './Component.css';

type Props = {
  filePath: string,
  fileName: string,
  onClose: () => void
}

type State = {
  fileUrl: string|null,
  loading: boolean
}

export default class extends React.PureComponent<Props, State> {

  state = {
    fileUrl: null,
    loading: true
  }

  componentDidMount() {
    this.loadFileUrl();
  }

  loadFileUrl = async () => {
    try {
      const { filePath } = this.props;
      const params = { path: filePath };
      const response = await getFileViewUri({ params });
      this.setState({ 
        fileUrl: response.data.data,
        loading: false 
      });
    } catch (error) {
      handleException(error);
      this.setState({ loading: false });
    }
  }

  getFileExtension = () => {
    const { fileName } = this.props;
    const parts = fileName.toLowerCase().split('.');
    return parts[parts.length - 1];
  }

  isImage = () => {
    const extension = this.getFileExtension();
    return ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp', 'svg'].includes(extension);
  }

  isPdf = () => {
    const extension = this.getFileExtension();
    return extension === 'pdf';
  }

  render() {
    const { fileName, onClose } = this.props;
    const { fileUrl, loading } = this.state;

    return (
      <Modal
        visible
        title={fileName}
        onCancel={onClose}
        footer={null}
        width="90%"
        style={{ top: 20 }}
        bodyStyle={{ height: 'calc(100vh - 200px)', padding: 0 }}
      >
        {loading && (
          <div className={styles.loadingContainer}>
            <Spin size="large" />
          </div>
        )}

        {!loading && fileUrl && this.isImage() && (
          <div className={styles.imageContainer}>
            <img src={fileUrl} alt={fileName} className={styles.image} />
          </div>
        )}

        {!loading && fileUrl && this.isPdf() && (
          <iframe
            src={fileUrl}
            title={fileName}
            className={styles.iframe}
          />
        )}

        {!loading && !fileUrl && (
          <div className={styles.errorContainer}>
            <p>Unable to load file</p>
          </div>
        )}
      </Modal>
    );
  }
}
